import bigDecimal from 'js-big-decimal';

export const convertNumberToPennies = (value) => parseInt(bigDecimal.multiply(value, 100), 10);
export const convertPenniesToDecimals = (value) => parseFloat(bigDecimal.divide(value, 100, 2));
export const roundDecimalMoney = (value) => bigDecimal.round(value, 2);
